module.exports = __webpack_public_path__ + "static/pill-violet-1a05f960074a145108fc74846656bdb2.svg";